import moment from "moment";

function XTime(X) {
  return moment(X * 1000).format("YYYY-MM-DD HH:mm:ss");
}

function StartTime(time = "day") {
  return moment().startOf(time).format("X");
}

function EndTime(time = "day") {
  return moment().endOf(time).format("X");
}

function monthTime(x) {
  switch (x) {
    case "start":
      return moment().startOf("month").format("YYYY-MM");
    case "start-prev":
      return moment().subtract(1, "month").startOf("month").format("YYYY-MM");
    case "end":
      return moment().endOf("month").format("YYYY-MM");
    case "end-prev":
      return moment().subtract(1, "month").endOf("month").format("YYYY-MM");
    default:
      return moment(x * 1000).format("YYYY-MM");
  }
}

function day(x) {
  switch (x) {
    case "start":
      return moment().startOf("month").format("YYYY-MM-DD");
    case "end":
      return moment().endOf("month").format("YYYY-MM-DD");
    default:
      return moment(x * 1000).format("YYYY-MM-DD");
  }
}

function difference(startTime, endTime) {
  if (endTime === null || endTime === undefined) {
    return " ";
  }
  if (endTime.toString().length === 10) {
    endTime = parseInt(endTime) * 1000;
  }
  if (endTime === 0) {
    endTime = new Date();
  }
  return moment(endTime).diff(moment(startTime * 1000), "minute");
}

function parseFormatDay(date) {
  if (!date) return "";
  return moment(date.getTime()).format("YYYY-MM-DD");
}

export {
  EndTime, StartTime, XTime, day, difference, monthTime, parseFormatDay
};

